import type { Event as SentryEvent } from '@sentry/react';
import { collectBrowserTranslationContext } from '../utils/browserTranslationContext';

/**
 * `beforeSend` enricher: tags every event with whether the browser was
 * translating the page at the time. Fails open — it never drops or rejects.
 *
 * Both tags are low-cardinality on purpose (a handful of states, a language
 * code) so they are safe to facet on in Sentry.
 */
export const enrichSentryEventWithBrowserTranslation = (
  event: SentryEvent,
): SentryEvent => {
  try {
    const context = collectBrowserTranslationContext();

    return {
      ...event,
      tags: {
        ...event.tags,
        document_lang: context.documentLanguage,
        browser_translation: context.translationState,
      },
      contexts: {
        ...event.contexts,
        browser_translation: {
          navigator_language: context.navigatorLanguage,
          navigator_languages: context.navigatorLanguages,
        },
      },
    };
  } catch {
    return event;
  }
};
